const overrides = (palette, typography) => ({
  root: {
    color: palette.icon,
    minWidth: 32
  }
})

export default overrides
